import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["element", "select"];

  connect() {
    for (let select of this.selectTargets) {
      this.toggleElements(this.getValue(select), select.dataset.toggleScope);
    }
  }

  changed(event) {
    this.toggleElements(this.getValue(event.target), event.target.dataset.toggleScope);
  }

  toggleElements(value, scope) {
    if (this.hasElementTarget) {
      for (let element of this.elementTargets) {
        if (element.dataset.toggleScope == scope) {
          this.toggle(element, element.dataset.values, element.dataset.valuesHide, value);
        }
      }
    }
  }

  toggle(element, values, valuesHide, value) {
    let hidden = false;

    // Vérifie si le champ est dans values (visible)
    if (values) {
      hidden = !values.split(",").includes(value);
    }

    // Vérifie si le champ est dans valuesHide (doit être caché)
    if (valuesHide && valuesHide.split(",").includes(value)) {
      hidden = true;
    }

    element.hidden = hidden;
  }

  getValue(select) {
    // Gère le cas d'un checkbox (true/false)
    if (select.type === "checkbox") {
      return select.checked.toString();
    }
    return select.value;
  }
}
